import { useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';

// context
import { MPosContext } from 'utils/context';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

// constant
import { FORM_TYPES } from 'utils/constants';

// components
import Header from 'widgets/header';
import ConfigurableForm from '../../widgets/configurableForm';
import { bootstrapUserPermissions } from 'utils/helpers/bootstrapUserPermissions';
import ErrorPage from 'widgets/errorScreen';

// styles
import { Wrapper } from './styles';
import {
    SegmentEventNameTypes,
    SegmentEventPages,
    SegmentEventPageTypes,
    SegmentEventActionTypes,
    SegmentEventActionNames,
    SegmentEventButtonNames,
} from 'utils/segment/constants';
import sendSegmentEvent from 'utils/segment';

function DealerDetails() {
    const {
        setPermissions,
        setUserDetails,
        setPartnerId,
        setLoggedUserRole,
        setLegalDetailsUploadedStatus,
        setActiveStage,
        setMetaData,
        setGstDetailsValid,
        setPermissionsMap,
        setGstDetailsSubmitAction,
        setFormConfigsMap,
        setSnackbar,
        formConfigsMap,
        permissions,
        userDetails,
    } = useContext(MPosContext);
    const formConfig = formConfigsMap[FORM_TYPES.DEALER_DETAILS];
    const router = useRouter();
    const [errorMessage, setErrorMessage] = useState('');
    const [showErrorScreen, setShowErrorScreen] = useState(false);
    const { isMobile } = useResponsiveDevice();
    if (!formConfig) {
        return null;
    }

    const { uiConfig, captured_data, details_update_required } = formConfig;

    if (!uiConfig || !Array.isArray(uiConfig)) {
        return null;
    }

    useEffect(() => {
        sendSegmentEvent(
            SegmentEventNameTypes.VIEW,
            {
                page_type: SegmentEventPageTypes.DEALER_DETAILS_PAGE,
                view_name: SegmentEventPages.VIEW_DEALER_DETAILS_PAGE,
            },
            {
                userDetails,
                isMobile,
            }
        );
    }, []);

    const onDealerFormSubmit = async () => {
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                page_type: SegmentEventPageTypes.DEALER_DETAILS_PAGE,
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.SUBMIT_MODAL,
                button_name: SegmentEventButtonNames.SUBMIT_MODAL,
            },
            { userDetails, isMobile }
        );

        await bootstrapUserPermissions({
            router,
            partnerId: userDetails.partner_id,
            groupName: permissions.group,
            setPermissions,
            setUserDetails,
            setMetaData,
            setPartnerId,
            setPermissionsMap,
            setLoggedUserRole,
            setLegalDetailsUploadedStatus,
            setActiveStage,
            setGstDetailsValid,
            setGstDetailsSubmitAction,
            setFormConfigsMap,
            setSnackbar,
            setErrorMessage,
            setShowErrorScreen,
            setIsLoading: () => {},
        });
    };

    if (showErrorScreen) {
        return <ErrorPage errorMessage={errorMessage} />;
    }

    const validator = ({ value, maxLength, regex }) => {
        if (regex && !new RegExp(regex).test(value)) {
            return 'Please enter a valid value';
        }
        if (maxLength && value.length > maxLength) {
            return 'Value is too long';
        }
        return '';
    };

    return (
        <Wrapper>
            <Header />
            <ConfigurableForm
                formType={FORM_TYPES.DEALER_DETAILS}
                uiConfig={uiConfig}
                initialValues={captured_data || {}}
                onSubmit={onDealerFormSubmit}
                setErrorMessage={setErrorMessage}
                setShowErrorScreen={setShowErrorScreen}
                validator={validator}
                shouldUpdateDetails={details_update_required}
            />
        </Wrapper>
    );
}

export default DealerDetails;
